'use strict';

const h = require('phy');

const shouldFade = ({ fadeNode }) => (fadeNode ? '.fade-out' : '');

const setProps = bhw => {
  const props = { role: 'alert' };
  if (bhw) {
    Object.assign(props, {
      'data-bhw': bhw,
      'data-bh-viewport': 'respect',
    });
  }
  return props;
};

const notificationComponent = props => {
  const { bhw, messageText, notificationKlass, touchRequest } = props;
  return h(
    touchRequest
      ? `.notification${notificationKlass}${shouldFade(props)}`
      : `${notificationKlass}`,
    setProps(bhw),
    messageText
  );
};

module.exports = notificationComponent;
